// extracted by mini-css-extract-plugin
export var quantityInput = "_g1-0";